import SvgIcon from "./SvgIcon.vue";
// import 'virtual:svg-icons-register'

const svgIconPlugin: any = {
  name: "SvgIcon",

  install(app: any): void {
    // 全局挂载
    app.component("SvgIcon", SvgIcon);
  }
};

export default svgIconPlugin;
